





















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { selectAddressPanel } from "@/components";
import { TbShop,TbSettingsPad } from '@/http';
import { Toast } from 'vant';
@Component({
  components: {
    
  },
})
export default class sySetting extends Vue {

    public $refs: {};
    //  用户信息
    userInfo = {}

    isEdit = false;
    btnloading = false;

    form = {
        payval: 1,
        xsset: true,
        mlset: 3,
        mrhykpay: true,
        zhpay: false,
        yybb:true,
        byj:false,
        thpay:false,
    };
    initform = {
        payval: 1,
        xsset: true,
        mlset: 3,
        mrhykpay: true,
        zhpay: false,
        yybb:true,
        byj:false,
        thpay:false,
    };
    // 除抹零
    setid2 = "";
    settingContent2 = null;
    // 抹零
    setid4 = "";
    settingContent4 = null;

    kqlist = [
        { name: "关闭", value: false },
        { name: "开启", value: true },        
    ];
    mlList = [
        { name: "不处理，不抹零", value: 3 },
        { name: "抹零到元：6.66 - 6.00", value: 2 },
        { name: "抹零到角：6.66 - 6.60", value: 1 },
    ];
    payList = [
        { name: "支付宝", value: 3, iskt: true },
        { name: "微信", value: 2, iskt: true },
        { name: "现金", value: 1, iskt: true },
    ];
    xlPayList = [
        { name: "线下微信", value: 1 },
        { name: "线下支付宝", value: 2 },
    ];
    otherPaySetting = null;
    
    created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }
    async mounted(){
        await this.init();
    }
    async init(){
        // 支付审核状态
        let res = await TbShop.GetTbShopApproveInfoByShopNo();
        this.payList = [
            {
                name: "支付宝",
                value: 3,
                iskt: res ? (res.alipayApproveStatus == 3 ? true : false) : false,
            },
            {
                name: "微信",
                value: 2,
                iskt: res ? (res.approveStatus == 3 ? true : false) : false,
            },
            { name: "现金", value: 1, iskt: true },    
        ];
        let padSetInfo1 = await TbSettingsPad.GetTbSettings({ settingtype: 2 });
        // 销售设置
        this.form.xsset =
        padSetInfo1.settingContent.isZeroStock != null
            ? padSetInfo1.settingContent.isZeroStock
            : true;
        // 语音播报
        this.form.yybb =
        padSetInfo1.settingContent.broadcast != null
            ? padSetInfo1.settingContent.broadcast
            : true;
        // 抹零
        let padSetInfo2 = await TbSettingsPad.GetTbSettings({ settingtype: 4 });
        this.form.mlset = padSetInfo2.settingContent.isRound
        ? padSetInfo2.settingContent.roundType == 1
            ? 2
            : padSetInfo2.settingContent.roundType == 2
            ? 1
            : 3
        : 3;
        // 支付方式
        this.form.payval =
        padSetInfo1.settingContent.paymentMethod != null
            ? Number(padSetInfo1.settingContent.paymentMethod.value) == 1
            ? 1
            : Number(padSetInfo1.settingContent.paymentMethod.value) == 2
            ? 2
            : Number(padSetInfo1.settingContent.paymentMethod.value) == 3
            ? 3
            : 1
            : 1;
        // 会员卡支付
        this.form.mrhykpay =
        padSetInfo1.settingContent.memberCard != null
            ? padSetInfo1.settingContent.memberCard
            : true;
        // 组合支付
        this.form.zhpay =
        padSetInfo1.settingContent.multiplePay != null
            ? padSetInfo1.settingContent.multiplePay
            : false;
        
        this.setid2 = padSetInfo1.id;
        this.settingContent2 = padSetInfo1.settingContent;
        this.setid4 = padSetInfo2.id;
        this.settingContent4 = padSetInfo2.settingContent; 

        // 其他支付方式
        let padSetInfo3 = await TbSettingsPad.GetTbSettings({ settingtype: 14 });
        this.otherPaySetting = padSetInfo3;

        let resByj = await TbShop.GetInitShopInfo({shopId:JSON.parse(localStorage.getItem('padShopInfo')).id});
        this.form.byj = resByj.isOpenImprest;
        //线上原路退款
        this.form.thpay = resByj.isOnlineRefund;
        this.initform = Object.assign({}, this.form);
    }
    // 选择销售设置
    selectset1(item,type) {
        switch (type) {
            case 1:
                this.form.xsset = item.value;
                break;
            case 2:
                this.form.yybb = item.value;
                break;
            case 3:
                this.form.mrhykpay = item.value;
                break;
            case 4:
                this.form.zhpay = item.value;
                break;
            case 5:
                this.form.mlset = item.value;
                break;
            case 6:
                if (!item.iskt) {
                    return;
                }
                this.form.payval = item.value;
                break; 
            case 7:
                this.form.payval = item.value;
                break; 
            case 8:
                this.form.byj = item.value;
                break; 
            case 9:
                this.form.thpay = item.value;
                break; 
            default:
                break;
        }
    }
    //编辑门店信息
    editInfo(){
        this.isEdit = true;
    }
    async cancelInfo(){
        this.isEdit = false;
        await this.init();
    }
    //保存门店信息
    async confirmInfo(){
        if(this.btnloading) return;
        try{
            this.btnloading = true;
            this.settingContent2.isZeroStock = this.form.xsset;
            this.settingContent2.paymentMethod = {
                index: 0,
                isSelect: true,
                value: this.form.payval,
            };
            this.settingContent2.broadcast = this.form.yybb;
            this.settingContent2.memberCard = this.form.mrhykpay;
            this.settingContent2.multiplePay = this.form.zhpay;
            this.settingContent4.isRound = this.form.mlset == 3 ? false : true;
            this.settingContent4.roundType =
                this.form.mlset == 3 ? 0 : this.form.mlset == 1 ? 2 : this.form.mlset == 2 ? 1 : 0;
            console.log(this.settingContent2, this.settingContent4);
            let res = await TbSettingsPad.PutTbSettings({
                id: this.setid2,
                settingContent: JSON.stringify(this.settingContent2),
            });
            let res2 = await TbSettingsPad.PutTbSettings({
                id: this.setid4,
                settingContent: JSON.stringify(this.settingContent4),
            });
            let res3 = await TbSettingsPad.PutTbSettings({
                id: this.otherPaySetting.id,
                settingContent: JSON.stringify(this.otherPaySetting.settingContent),
            });
            let res4 = await TbShop.OpenImprest({isOpenImprest:this.form.byj});
            //线上原路退款
            let res5 = await TbShop.OpenOnlineRefund({isOnlineRefund:this.form.thpay});
            Toast("保存成功");
            this.cancelInfo();
            this.btnloading = false;
        }catch {
            this.btnloading = false;
        }
    }
    /**选择其他支付方式 */
    selectOth(item){
        switch (item.value) {
            case 1:
                this.otherPaySetting.settingContent.offlineWeChat.isSelect = !this.otherPaySetting.settingContent.offlineWeChat.isSelect;
                break;
            case 2:
                this.otherPaySetting.settingContent.offlineAlipay.isSelect = !this.otherPaySetting.settingContent.offlineAlipay.isSelect;
                break;
        
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/sySetting.vue